import Flickity from 'flickity';

import NutritionTextSection from '../components/NutritionTextSection';
import HeroComponent from '../components/hero';
import Clouds from '../modules/Clouds';
import Modal from '../modules/Modal';

/* global Back, TweenMax, TimelineMax, Power2, Elastic, Hammer, TweenLite */

export default class NutritionController {

  constructor(options) {
    this.options = options;
    console.log('NUTRITION CONTROLLER');

    this.currentStage = 0;
    this.prevStage = -1;
    this.n_text_sections = [];
    this.totSections = 5;
    this.master_animation = {};
    this.hasSwipeEvents = false;
    this.seeking = false;

    $('nav.siteNav__main>div>a.submenu__nutrition').addClass('is-activepage');

    let numClouds = 20;

    if ( $(window).width() < 768 ) {
      numClouds = 10;
    }

    this.clouds = new Clouds({ num:numClouds, elem:$('div.n_clouds') });

    for ( let i = 0; i < $('div.n_section').length; i += 1 ) {
      this.n_text_sections.push( new NutritionTextSection({
        elem:$(`div.n_section:eq(${i})`),
        name:`TextSection${i}`,
      }));
    }

    this.hammertime = new Hammer( document.getElementById('nutrition') );
    this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

    this.learnMoreModal = new Modal({
      id : 'n_learnMore',
      buttonClass : '.open__modal',
    });

    $('html').addClass('no-scroll');
    $('footer a,footer input').attr('tabindex', '-1');
    $('.product__items a').attr('tabindex', '-1');

    this.home_products = new HeroComponent({
      elem      :'section.nutrition__details',
    });

    this.addSwipeEvents();

    this.setupStage();

    $('.n_dot').click( (e) => {
      this.doSeekStage(e);
    });

    $(window).on('load', () => {
      // make sure we scroll to the top of the page before enabling the scroll magic
      setTimeout(() => {
        scrollTo(0, -1);
      }, 0);
    });

    this.flkty = new Flickity( 'div.n_compare_items', {
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      arrowShape: { x0: 0, x1: 40, y1: 50, x2: 45, y2: 50, x3: 5 },
      accessibility: false,
    });

    this.swipetip = setInterval( () => {
      TweenLite.fromTo( $('#swipeTip'), 0.4, { y:0, scale: 0.6 }, { y:-40, scale:1, opacity: 0.4, ease: Power2.easeOut });
      TweenLite.to( $('#swipeTip'), 0.4, { y: -80, opacity: 0, delay:0.4, ease: Power2.easeIn });
    }, 3000);


    $(window).keydown( (e) => {
      if ( e.keyCode === 39 || e.keyCode === 40 ) {
        this.doNextStage();
      } else if ( e.keyCode === 37 || e.keyCode === 38 ) {
        this.doPrevStage();
      }
    });

    $('.n_arrow_top').click( () => this.doPrevStage() );
    $('.n_arrow_bottom').click( () => this.doNextStage() );

    this.handleResize();

    $(window).scroll( e => this.handleScroll(e) );
    $(window).on('mousewheel DOMMouseScroll', e => this.handleMouseWheel(e) );
    $(window).resize( () => this.handleResize() );

    this.arrowdownAni = {};
    this.showDownArrow();

    $('.n_arrowdown').click( () => {
      if (this.currentStage === 1) {
        this.doNextStage();
      } else if (this.currentStage === this.totSections) {
        const offset = $('section.nutrition__products').offset().top - ( $(window).height() / 2 );
        $('html, body').animate({ scrollTop: `${offset}px` }, 500);
      }
    });

  }

  showDownArrow() {
    this.arrowdownAni = TweenMax.fromTo( $('.n_arrowdown'), 1, { y:-40, scale: 1, opacity: 0 }, { repeat:1, repeatDelay: 2, delay: 2, y: 0, scale: 1, opacity: 1, ease: Back.easeOut });
  }

  hideDownArrow() {
    console.log(this.arrowdownAni);
    this.arrowdownAni.pause();
    TweenMax.to($('.n_arrowdown'), 1, { y: -40, opacity: 0, ease: Back.easeIn });
  }

  doSeekStage(e) {
    if (!this.isAnimating) {
      $('section.nutrition').addClass('is-seeking');
      this.seeking = parseInt( $(e.currentTarget).attr('id').replace('nav_stage', ''), 10 );

      // console.log('SEEKING NAV CLICK: ', 'stage', this.seeking, 'TweenTo:', parseInt( this.seeking, 10 ) );

      setTimeout( () => {
        this.doStageTransition(this.seeking, true);
        this.breakScrollJack();
      }, 350);

      clearInterval(this.swipetip);
    }
  }

  doPrevStage() {
    const bEgg = $('#b_egg');

    if ( this.currentStage > 1) {
      console.log('GOING TO PREV STAGE: stage', (this.currentStage - 1));

      if ( this.currentStage <= 2 ) {
        bEgg.addClass('is-behind');
      } else {
        bEgg.removeClass('is-behind');
      }

      this.doStageTransition( this.currentStage - 1 );
      this.breakScrollJack();
    }

  }

  doNextStage() {
    const bEgg = $('#b_egg');

    if ( this.currentStage < this.totSections ) {
      // console.log('GOING TO NEXT STAGE: stage', (this.currentStage + 1 ));

      if ( this.currentStage === 1 ) {
        bEgg.addClass('is-behind');
      } else {
        bEgg.removeClass('is-behind');
      }

      this.doStageTransition(this.currentStage + 1);
      this.breakScrollJack();
    }

  }

  doStageTransition(stage, seek = false) {
    this.currentStage = stage;
    this.isAnimating = true;

    $(`.n_stage${this.currentStage}`).css('visibility', 'visible');
    this.stopInputParallax();

    if (!seek) {
      this.master_animation.tweenTo(`stage${stage}`, { onComplete: () => this.completeStageTransition() } );
    } else {
      scrollTo(0, -1);
      this.master_animation.pause(`stage${stage}`, false );
      $('section.nutrition').removeClass('is-seeking');
      // a11y
      $('.n_section').css('visibility', 'hidden');
      $(`.n_stage${this.currentStage}`).css('visibility', 'visible');

      this.isAnimating = false;
    }

    if ( this.currentStage === 1 || this.currentStage === this.totSections ) {
      this.showDownArrow();
    } else {
      this.hideDownArrow();
    }

    $('.n_dot').removeClass('is-active');
    $(`.n_dot:eq(${(this.currentStage - 1)})`).addClass('is-active');

    clearInterval(this.swipetip);
  }

  completeStageTransition() {
    this.isAnimating = false;
    console.log('TRAN END: n_stage', this.currentStage);

    $('.n_section').css('z-index', '');
    $('.n_section').css('visibility', 'hidden');
    $('.n_section').attr('aria-hidden', 'true');
    $(`.n_stage${this.currentStage}`).css('z-index', '600');
    $(`.n_stage${this.currentStage}`).css('visibility', 'visible');
    $(`.n_stage${this.currentStage}`).attr('aria-hidden', 'false');
  }

  breakScrollJack() {

    // if the current stage is the last stage, break the scroll jacking
    console.log(this.currentStage, this.totSections);
    if ( this.currentStage === this.totSections ) {

      setTimeout( () => {
        console.log('DISABLE JACKING');
        if (this.hasSwipeEvents) {
          this.removeSwipeEvents();
        }

        $('footer a,footer input').attr('tabindex', '');
        $('.product__items a').attr('tabindex', '');

        $('html').removeClass('no-scroll');
      }, 1000);

    } else {

      // engage scrolljacking
      setTimeout( () => {
        console.log('ENABLE JACKING', this.hasSwipeEvents);
        scrollTo(0, -1);

        $('footer a,footer input').attr('tabindex', '-1');
        $('.product__items a').attr('tabindex', '-1');

        if (!this.hasSwipeEvents) {
          this.addSwipeEvents();
        }
        $('html').addClass('no-scroll');
      }, 500);

    }

  }

  addSwipeEvents() {
    console.log('ADDING SWIPE EVENTS', this.hammertime);

    this.hammertime.set({ enable: true });
    this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

    this.hammertime.on('swipeup', () => {
      this.doNextStage();
      console.log('HAMMER SWIPE UP!');
    });

    this.hammertime.on('swipedown', () => {
      this.doPrevStage();
      console.log('HAMMER SWIPE DOWN!');
    });

    this.hasSwipeEvents = true;

  }

  removeSwipeEvents() {
    console.log('REMOVING SWIPE EVENTS', this.hammertime);
    this.hammertime.set({ enable: false });
    this.hammertime.off('swipeup swipedown');
    this.hasSwipeEvents = false;
  }

  setupStage() {
    const clouds = $('div.n_clouds');
    const wEgg = $('#w_egg');
    const bEgg = $('#b_egg');
    const bEggL1 = $('#b_egg div.n_egg_mem');
    const bBggL2 = $('#b_egg div.n_egg_yolk');
    const bEggL3 = $('#b_egg div.n_egg_front');
    const bEggL4 = $('#b_egg div.n_egg_white');
    const eggs = $('.n_egg_cntr');
    const grass = $('.farm>.grass');
    const barn = $('.farm>.barn');
    const hill1 = $('.farm>.hill1');
    const hill2 = $('.farm>.hill2');

    const stage1HL = $('div.n_intro');

    const stage2HL = $('div.n_whitebrown');

    const stage3HL = $('div.n_outershell');

    const stage2CO1 = $('#n_eggshell_1');
    const stage2CO2 = $('#n_eggshell_2');

    const stage3CO1 = $('#n_eggwhite_1');
    const stage3CO2 = $('#n_eggwhite_2');

    const stage4HL = $('div.n_eggwhite');
    const stage4CO1 = $('#n_yolk_1');
    const stage4CO2 = $('#n_yolk_2');

    const stage5HL = $('div.n_stage5');

    const stage6HL = $('div.n_stage6');

    let s1EggSeparation = 200;

    let s2EggHeight = 0;

    let s7EggPosX = -373;
    let s7EggPosY = 67;
    let s7EggOpac = 1;

    if ( $(window).width() < 568 ) {
      s1EggSeparation = 100;

      s7EggPosX = 0;
      s7EggPosY = -74;
      s7EggOpac = 0.2;

      s2EggHeight = -60;

    } else if ( $(window).width() < 740 ) {
      s7EggPosY = 45;
      s7EggPosX = -126;
      s7EggOpac = 0.2;
    } else if ( $(window).width() < 900 ) {
      s7EggPosX = -160;
      s7EggOpac = 0.2;
    }

    this.master_animation = new TimelineMax()

      .add('init')
      .fromTo(eggs, 1, { y:-200 }, { y: 0, opacity:1, ease: Back.easeOut.config(1.4) })
      .to(wEgg, 0.1, { scale: 1.1, ease: Back.easeInOut.config(1.4) }, 'init+=0' )
      .fromTo(stage1HL, 0.75, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'init+=0.5')
      .fromTo(grass, 0.5, { y:100 }, { y: 0, opacity:1, ease: Back.easeOut.config(1.4) }, 'init+=0.1' )
      .fromTo(hill1, 0.5, { y:100 }, { y: 0, opacity:1, ease: Back.easeOut.config(1.4) }, 'init+=0.25')
      .fromTo(hill2, 0.5, { y:100 }, { y: 0, opacity:1, ease: Back.easeOut.config(1.4) }, 'init+=0.4')
      .fromTo(barn, 1.5, { rotationX: 90 }, { rotationX: 0, opacity:1, transformPerspective:200, ease: Elastic.easeOut.config(1, 0.4) }, 'init+=0.5')

      .add('stage1')
      .to(stage1HL, 0.35, { y:-40, opacity: 0, ease: Back.easeIn.config(1.4) })
      .to(clouds, 0.75, { opacity: 0.4 } )
      .to(barn, 0.5, { rotationX: 90, opacity:0, transformPerspective:200, ease: Back.easeIn.config(1.2) }, 'stage1+=0')
      .to(hill1, 0.5, { y:100, opacity:0, ease: Back.easeIn.config(1.4) }, 'stage1+=0.15')
      .to(hill2, 0.5, { y:100, opacity:0, ease: Back.easeIn.config(1.4) }, 'stage1+=0.2')
      .to(grass, 0.3, { y:100, opacity:0, ease: Back.easeIn.config(1.4) }, 'stage1+=0.4' )
      .to(wEgg, 0.8, { x: -s1EggSeparation, y:s2EggHeight, scale: 0.9, opacity:1, ease: Back.easeInOut.config(1.4) }, 'stage1+=0.3' )
      .fromTo(bEgg, 0.8, { scale:0.7, opacity:1 }, { x: s1EggSeparation, y:s2EggHeight, opacity:1, scale:0.9, ease: Back.easeInOut.config(1.2) }, 'stage1+=0.3')
      .fromTo(stage2HL, 0.5, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage1+=1.0')
      .fromTo(stage2CO1, 0.35, { y:40, opacity:0 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage1+=1.1')
      .fromTo(stage2CO2, 0.35, { y:40, opacity:0 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage1+=1.2')

      .add('stage2')
      .to(stage2CO1, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) }, 'stage2+=0.1')
      .to(stage2CO2, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) }, 'stage2+=0.2')
      .to(stage2HL, 0.35, { y:-40, opacity: 0, ease: Back.easeIn.config(1.4) })
      .to(wEgg, 0.75, { x: 0, y:0, scale: 0.8, ease: Back.easeInOut.config(1.4) }, 'stage2+=0.3' )
      .to(bEgg, 0.75, { scale: 2, y:0, x:0, ease: Back.easeInOut.config(1.4) }, 'stage2+=0.3' )
      .to(bEggL3, 0.5, { scale:1, opacity: 0, ease: Power2.easeIn }, 'stage2+=0.7' )
      .to(bEggL4, 0.5, { opacity:1, ease: Back.easeInOut.config(1.4) }, 'stage2+=0.20' )
      .fromTo(stage3HL, 0.5, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage2+=1.0')
      .fromTo(stage3CO1, 0.35, { y:40, opacity: 0 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage2+=1.1')
      .fromTo(stage3CO2, 0.35, { y:40, opacity:0 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage2+=1.2')

      .add('stage3')
      .to(stage3CO1, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) })
      .to(stage3CO2, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) }, 'stage3+=0.2')
      .to(stage3HL, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) }, 'stage3+=0.15')
      .to(bEgg, 0.5, { scale: 3.2, y:-100, x:0, ease: Back.easeInOut.config(1.4) }, 'stage3+=0.5' )
      .to(wEgg, 0.5, { opacity:0 }, 'stage3+=0.5' )
      .to(bEggL1, 0.75, { opacity:1, ease: Back.easeInOut.config(1.4) }, 'stage3+=0.50' )
      .fromTo(stage4HL, 0.5, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage3+=1')
      .fromTo(stage4CO1, 0.35, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage3+=1.0')
      .fromTo(stage4CO2, 0.35, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage3+=1.1')

      .add('stage4')
      .to(stage4CO1, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) })
      .to(stage4CO2, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) }, 'stage4+=0.1')
      .to(stage4HL, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) })
      .to(bEgg, 0.5, { scale: 1.5, y:0, x:0, ease: Back.easeInOut.config(1.4) }, 'stage4+=0.5' )
      .to(bBggL2, 0.5, { opacity:1, ease: Back.easeInOut.config(1.4) }, 'stage4+=0.50' )
      .to(bEggL1, 0.25, { opacity:0, ease: Back.easeInOut.config(1.4) }, 'stage4+=0.75' )
      .fromTo(stage5HL, 0.5, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage4+=1')

      .add('stage5')
      .to(stage5HL, 0.35, { y:40, opacity: 0, ease: Back.easeIn.config(1.4) } )
      .to(bEggL3, 0.5, { scale: 1, opacity: 1, ease: Power2.easeOut }, 'stage5+=0.4' )
      .to(bEgg, 0.5, { scale: 0.8, y:s7EggPosY, x:s7EggPosX, opacity: s7EggOpac, ease: Back.easeInOut.config(1.4) }, 'stage5+=0.4' )
      .to(bBggL2, 0.5, { opacity:0, ease: Back.easeIn.config(1.4) }, 'stage5+=0.5' )
      .fromTo(stage6HL, 0.5, { y:40 }, { y:0, opacity: 1, ease: Back.easeOut.config(1.4) }, 'stage5+=0.6')

      .add('stage6');


    this.doStageTransition(1);

  }

  stopInputParallax() {
    $('section.nutrition').off('mousemove mouseover mouseout');
  }

  startInputParallax() {

    $('section.nutrition').mousemove( (e) => {
      this.pX = e.pageX / $(window).width();
      this.pY = ( e.pageY - $(window).scrollTop() ) / $(window).height();

      this.mX = ( 15 * this.pX ) - 7.5;
      this.mY = ( 15 * this.pY ) - 7.5;

      this.hX = ( 15 * this.pX ) - 7.5;
      this.hY = ( 15 * this.pY ) - 7.5;
    });

    $('section.nutrition').mouseover( () => {
      this.mousedOver = true;
      window.requestAnimationFrame( () => this.updateUI() );
    } );

    $('section.nutrition').mouseout( () => {
      this.mousedOver = false;
    } );

  }

  scrollTracker() {
    const st = $(window).scrollTop();
    const triggerY = $('div.n_trigger').offset().top - st;  // 50% of the VP height
    let section = 0;

    for ( let i = 0; i < $('div.n_track>div').length; i += 1) {

      if ( $(`div.n_track>div:eq(${i})`).offset().top - st < triggerY ) {
        section = i;
      } else {

        if ( section !== this.currentSection ) {
          this.prevSection = this.currentSection;
          this.currentSection = section;
          console.log('IN SECTION ', section);
        }

        break;

      }
    }
  }

  handleScroll() {
    console.log('SCROLLING');

    if ( $(window).scrollTop() === 0 && !this.hasSwipeEvents ) {
      console.log('ADDING SCROLL EVENTS!');
      this.addSwipeEvents();
      $('html').addClass('no-scroll');
    }

  }

  handleResize() {

// console.log('RESIZE:',$(window).width() < 575, $(window).height() < 350 );
    if ( $(window).width() <= 600 && $(window).height() <= 350 && !$('div.modal.nutrition__turn__device').hasClass('is-active') ) {
      // assuming the phone is small and being held horizontally
      $('div.modal.nutrition__turn__device').addClass('is-active');
    } else if ( $('div.modal.nutrition__turn__device').hasClass('is-active') ) {
      $('div.modal.nutrition__turn__device').removeClass('is-active');
    }

  }

  handleMouseWheel(e) {
    const st = $(window).scrollTop();

    if ( e.originalEvent.wheelDelta > 0 ) {
      if ( e.originalEvent.wheelDelta > 20 && !this.isAnimating && st === 0 ) {
        this.doPrevStage();
      }
    } else if ( e.originalEvent.wheelDelta < 0 ) {
      if ( e.originalEvent.wheelDelta < -20 && !this.isAnimating && st === 0 ) {
        this.doNextStage();
      }

    }

  }

  // setup the UI render loop for all elements within the component
  updateUI() {

    if ( this.mousedOver ) {
      window.requestAnimationFrame( () => this.updateUI() );
      $('section.nutrition div.n_egg').css('transform', `rotateY(${this.mX}deg) rotateX(${this.mY}deg)` );
    }

  }


}



// WEBPACK FOOTER //
// ./js/controllers/pages/NutritionController.js